<template>
  <auth-guard
    route
  >
    <base-title title="Create Yard" />
    <write-yard-info
      :statuses="statuses"
      @addYardInfo="createNewYard"
    />
  </auth-guard>
</template>

<script>
import WriteYardInfo from './Write/WriteYardInfo'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CreateYard',
  components: {
    WriteYardInfo
  },
  data: () => ({
    step: 1,
    id: null,
    prevNumOrgs: 0,
    orgInfiniteDistance: 0,
    addingContactInfo: false,
    creating: true,
    yard: null
  }),
  methods: {
    ...mapActions('yardStore', [
      'createYard',
      'updateYard'
    ]),
    /**
     * Create a new yard
     * @param {Object} body
     */
    async createNewYard (body) {
      const res = await this.createYard(body)
      if (res.id) {
        this.$router.push({ name: 'yard', params: { id: res.id } })
      }
    }
  },
  computed: {
    ...mapGetters({
      statuses: 'businessStatuses',
      yardDays: 'yardStore/yardDays'
    })
  }
}
</script>
